export const PC_COUNT_OF_SNOW = 49;

export const MW_COUNT_OF_SNOW = 29;
